import { jsxs as a, jsx as e } from "react/jsx-runtime";
import * as r from "react";
import { forwardRef as c } from "react";
import { c as n } from "./index.js-Cr0Rsuyz.mjs";
import { N as d } from "./number-indicator-8TCZz0mp.mjs";
function h(t, l) {
  return /* @__PURE__ */ r.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: l
  }, t), /* @__PURE__ */ r.createElement("path", {
    fill: "currentColor",
    d: "M5.25 5.097c0-1.02.784-1.847 1.75-1.847s1.75.827 1.75 1.847v13.806c0 1.02-.784 1.847-1.75 1.847s-1.75-.827-1.75-1.847zM15.25 5.097c0-1.02.784-1.847 1.75-1.847s1.75.827 1.75 1.847v13.806c0 1.02-.784 1.847-1.75 1.847s-1.75-.827-1.75-1.847z"
  }));
}
var u = n(/* @__PURE__ */ c(h));
function v(t, l) {
  return /* @__PURE__ */ r.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: l
  }, t), /* @__PURE__ */ r.createElement("path", {
    fill: "currentColor",
    d: "M18.42 9.87c1.589.976 1.589 3.285 0 4.26L8.196 20.408c-1.665 1.023-3.808-.176-3.808-2.13V5.724c0-1.955 2.143-3.154 3.808-2.13z"
  }));
}
var p = n(/* @__PURE__ */ c(v));
const w = ({
  isPlaying: t,
  currentPage: l,
  totalPages: i,
  transitionDurationMs: o = 300,
  onPlayChange: m,
  onClickAll: f
}) => {
  const s = t ? "일시정지" : "재생";
  return /* @__PURE__ */ a("div", { className: "flex h-32 w-[258px] items-center pc:h-48 pc:w-[509px]", children: [
    /* @__PURE__ */ a("div", { className: "relative flex items-center justify-center", children: [
      /* @__PURE__ */ e(
        "button",
        {
          "aria-label": s,
          className: "relative flex size-32 shrink-0 items-center justify-center pc:size-42",
          onClick: m,
          title: s,
          type: "button",
          children: /* @__PURE__ */ e("div", { className: "size-14 pc:size-24", children: t ? /* @__PURE__ */ e(u, { className: "size-full" }) : /* @__PURE__ */ e(p, { className: "size-full" }) })
        }
      ),
      /* @__PURE__ */ e("div", { className: "absolute right-4 h-8 w-1 bg-line-neutral-weak2 pc:h-16" })
    ] }),
    /* @__PURE__ */ a("div", { className: "relative ml-6 mr-10 flex grow items-center", children: [
      /* @__PURE__ */ e("div", { className: "h-1 w-full rounded-10 bg-fill-neutral-weak3 pc:h-2" }),
      /* @__PURE__ */ e(
        "div",
        {
          className: "absolute h-2 rounded-[2rem] bg-fill-neutral-main transition-transform pc:h-4",
          style: {
            width: `${1 / i * 100}%`,
            transform: `translateX(${(l - 1) * 100}%)`,
            transitionDuration: `${o}ms`
          }
        }
      )
    ] }),
    /* @__PURE__ */ e(d, { currentPage: l, onClickAll: f, totalPages: i })
  ] });
};
w.displayName = "NDS.PageIndicator";
export {
  w as P
};
